module.exports = __webpack_public_path__ + "themes/fq/font/proximasoft-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/proximasoft-regular-webfont.woff
// module id = 96
// module chunks = d-game